import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=2de73c2d"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de73c2d')) {
      api.createRecord('2de73c2d', component.options)
    } else {
      api.reload('2de73c2d', component.options)
    }
    module.hot.accept("./contacts.vue?vue&type=template&id=2de73c2d", function () {
      api.rerender('2de73c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerInformation/contacts.vue"
export default component.exports